import { Text, Flex } from 'vvs-uikit'
import PixelatedImage from './PixelatedImage'

export const LoadingView: React.FC<{ imageSrc?: string }> = ({ children, imageSrc }) => {
  return (
    <Flex flexDirection="column" justifyContent="center" alignItems="center" mb={3}>
      <PixelatedImage src={imageSrc ?? '/images/loadingDiamond.gif'} width="80px" />
      {typeof children === 'string' ? (
        <Text color="black" fontWeight="600" my="8px">
          {children}
        </Text>
      ) : (
        children
      )}
    </Flex>
  )
}
